import { render } from "./BananaSearchResult.vue?vue&type=template&id=36292caa&scoped=true"
import script from "./BananaSearchResult.vue?vue&type=script&lang=js"
export * from "./BananaSearchResult.vue?vue&type=script&lang=js"

import "./BananaSearchResult.vue?vue&type=style&index=0&id=36292caa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36292caa"]])

export default __exports__